import en from './en';
import es from './es';
import translate from '../index';

const Translate = () => translate('navigation', [en, es]);

export default Translate();
